module.exports = __webpack_public_path__ + "static/media/prod.e43c2672.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/prod.jpg
// module id = 1219
// module chunks = 0